import { call, put } from '@redux-saga/core/effects'
import axios from 'axios'
import { Action } from '../../../../common/store/sagas/root'
import { userDelete } from '../../../api/userDelete'
import { hip_userDeleteError, hip_userDeleteSuccess } from '../../../actions/hipUsers/actions'

export function* sagaUserDelete({ payload }: Action<number>) {
  try {
    const response: number = yield call(userDelete, payload)
    yield put(hip_userDeleteSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(hip_userDeleteError(error.response.data as unknown))
    } else {
      yield put(hip_userDeleteError(error))
      throw error
    }
  }
}
